import React from 'react';
import GenericSection from '../components/sections/GenericSection';
import SectionHeader from '../components/sections/partials/SectionHeader';

const DataProcessingAgreement = () => {
  const sectionHeader = {
    title: 'Data Processing Agreement (DPA)',
    paragraph: 'Last updated: March 2026'
  };

  return (
    <GenericSection>
      <div className="container-xs">
        <SectionHeader tag="h1" data={sectionHeader} />

        <p>This Data Processing Agreement (&quot;DPA&quot;) forms part of the Terms and Conditions.</p>

        <hr />

        <h3>1. Roles</h3>
        <ul>
          <li>Customer = Data Controller</li>
          <li>Service Provider = Data Processor</li>
        </ul>

        <hr />

        <h3>2. Subject Matter</h3>
        <p>Processing of data to provide natural language querying of WooCommerce databases.</p>

        <hr />

        <h3>3. Duration</h3>
        <p>Processing continues for the duration of the service agreement.</p>

        <hr />

        <h3>4. Nature and Purpose of Processing</h3>
        <ul>
          <li>Translating user queries into SQL</li>
          <li>Executing read-only queries</li>
          <li>Formatting results</li>
        </ul>

        <hr />

        <h3>5. Categories of Data</h3>
        <ul>
          <li>Customer data (as stored in WooCommerce)</li>
          <li>User account data</li>
          <li>Anonymised prompts</li>
        </ul>

        <hr />

        <h3>6. Data Subjects</h3>
        <ul>
          <li>Customers of the WooCommerce store</li>
          <li>Users of the Service</li>
        </ul>

        <hr />

        <h3>7. Processor Obligations</h3>
        <p>We will:</p>
        <ul>
          <li>Process data only on documented instructions</li>
          <li>Ensure confidentiality</li>
          <li>Implement appropriate security measures</li>
          <li>Assist with data subject rights requests</li>
          <li>Notify of data breaches without undue delay</li>
        </ul>

        <hr />

        <h3>8. Subprocessors</h3>
        <p>We may engage subprocessors including:</p>
        <ul>
          <li>AI providers</li>
          <li>Cloud infrastructure providers</li>
        </ul>
        <p>We ensure appropriate safeguards are in place.</p>

        <hr />

        <h3>9. Security Measures</h3>
        <ul>
          <li>PII masking before AI processing</li>
          <li>Read-only database access</li>
          <li>Tenant-based data isolation</li>
          <li>Access controls</li>
        </ul>

        <hr />

        <h3>10. International Transfers</h3>
        <p>Where data is transferred outside the EEA, appropriate safeguards are used (e.g. SCCs).</p>

        <hr />

        <h3>11. Data Deletion</h3>
        <p>Upon termination:</p>
        <ul>
          <li>Data will be deleted or returned upon request</li>
          <li>Logs are retained only for limited operational purposes</li>
        </ul>

        <hr />

        <h3>12. Audits</h3>
        <p>We will provide reasonable information to demonstrate compliance upon request.</p>

        <hr />

        <h3>13. Liability</h3>
        <p>Each party is responsible for its own compliance with applicable data protection laws.</p>

        <hr />

        <h3>14. Contact</h3>
        <p className="mb-0">Exanta AI</p>
        <p className="mt-8">
          <a href="mailto:support@exanta.ai">support@exanta.ai</a>
        </p>
      </div>
    </GenericSection>
  );
};

export default DataProcessingAgreement;
